import React, {useEffect, useState} from 'react';
import aboutImg from '../assets/images/about.JPG';
import border from '../assets/images/border.png'

function About(){

    const [width, setWidth] = useState(0);

    const getWidth = () => {
        setWidth(window.innerWidth)
    }

    useEffect(() => {
        getWidth();
        window.addEventListener('resize', getWidth);
    },[])

    return(
        <section id="about">
            <div className="about-page">
                <div className="about-style">
                    <div className="about-content">
                        <div className="about-img" data-aos="fade-right">
                            <img src={aboutImg} alt="about-img"></img>
                        </div>
                        <div className="about-detail" data-aos="fade-left">
                            <h3>About Us</h3>
                            <p>Ikatan Remaja Islam Nurul Falah (IRINA) adalah sebuah organisasi remaja masjid yang bergerak pada bidang sosial di bawah naungan Yayasan Nurul Falah Amanah
                                yang berlokasi di Masjid Nurul Falah, Komplek Kembang Larangan. Kami mempunyai banyak kegiatan dari setiap departemen yang terdapat pada IRINA.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="about-border">
                    <img src={border} alt="border" width={width} height="auto"></img>
                </div>
            </div>
        </section>
    )
}

export default About